<template>
  <div v-if="selectedVehicleMaintenance">
    <div class="modal fade" role="dialog" ref="vehiclemaintenanceitemmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header">
          <button type="button" class="btn btn-default pull-right" data-dismiss="modal">
            <i class="ic-close"></i>
          </button>
        </div>
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <!-- Start: Form -->
                  <div class="row cRow">
                    <div class="col-sm-7 divider-right pr-30">
                      <h4>
                        Maintenance Detail
                        <span class="text-edited"></span>
                      </h4>
                      <div>
                        <h6>Please fill all information below.</h6>
                        <form role="form" action="#" id="vehicle-maintenance-item-form">
                          <div class="row">
                            <div class="col-sm-8 prz">
                              <div class="form-group">
                                <label>SparePart</label>
                                <input
                                  class="form-control"
                                  type="text"
                                  name="sparePart"
                                  v-model="model.sparePart"
                                  maxlength="100"
                                  required
                                  :disabled="isMaintenanceDone"
                                />
                                <small
                                  class="form-text text-danger"
                                  v-if="validationErrors.sparePart"
                                  v-text="validationErrors.sparePart"
                                ></small>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label>New?</label>
                                <input
                                  type="checkbox"
                                  name="isNewSparePart"
                                  v-model="model.isNewSparePart"
                                  :disabled="isMaintenanceDone"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>Description</label>
                            <input
                              class="form-control"
                              type="text"
                              name="description"
                              v-model="model.description"
                              maxlength="100"
                              :disabled="isMaintenanceDone"
                            />
                          </div>
                          <div class="form-group">
                            <label>
                              Cost
                              <span class="--grey50"
                                >({{ selectedVehicleMaintenance.providerCurrency }})</span
                              >
                            </label>
                            <input
                              class="form-control"
                              type="number"
                              name="cost"
                              v-model="model.cost"
                              min="0"
                              step="any"
                              :disabled="isMaintenanceDone"
                            />
                          </div>
                          <div class="modal-footer" v-if="!isMaintenanceDone">
                            <button
                              type="button"
                              class="btn btn-default"
                              @click.prevent="reset()"
                            >
                              Reset
                            </button>
                            <button
                              v-if="!isEdit"
                              type="submit"
                              class="btn btn-primary"
                              @click.prevent="createItem()"
                            >
                              Create
                            </button>
                            <button
                              v-if="isEdit"
                              type="submit"
                              class="btn btn-primary"
                              @click.prevent="updateItem()"
                            >
                              Update
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-5 text-center">
                      <div class="cars-image">
                        <img :src="cdn + '/images/hiace.jpg'" alt class="cars-image" />
                      </div>
                      <h4 class="--grey25">
                        {{ selectedVehicleMaintenance.vehicleFactory }}
                        {{ selectedVehicleMaintenance.vehicleModel }}
                      </h4>
                      <div class="plate-number">
                        {{ selectedVehicleMaintenance.vehiclePlateNumber }}
                      </div>
                      <p>
                        {{ selectedVehicleMaintenance.vehicleYearManufactured }}
                        &bull;
                        {{ selectedVehicleMaintenance.vehicleTransmission }}
                        &bull;
                        {{ selectedVehicleMaintenance.vehicleClassType }} &bull;
                        {{ selectedVehicleMaintenance.vehicleType }}
                      </p>
                      <div class="provider_location">
                        <i class="ic-pointGPS"></i>
                        {{ selectedVehicleMaintenance.providerName }}
                      </div>
                    </div>
                  </div>
                  <!-- End: Form -->

                  <!-- Start: Table -->
                  <div class="table-modal-detail">
                    <div class="table-responsive table-accordion">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>SparePart</th>
                            <th>Description</th>
                            <th>New SparePart?</th>
                            <th>Cost</th>
                            <th class="text-center" v-if="!isMaintenanceDone">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in items" :key="item.id">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item.sparePart }}</td>
                            <td>{{ item.description }}</td>
                            <td>{{ item.isNewSparePart }}</td>
                            <td>{{ item.providerDefaultCurrency }} {{ item.cost }}</td>
                            <td class="text-center">
                              <div
                                class="button-action-wrapper"
                                v-if="!isMaintenanceDone"
                              >
                                <button
                                  class="btn btn-default"
                                  type="button"
                                  @click="bindModel(item)"
                                >
                                  <span>Edit</span>
                                </button>
                                <button
                                  class="btn btn-default"
                                  type="button"
                                  @click="deleteItem(item)"
                                >
                                  <i class="ic-close"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- End: Table -->
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import vehicleRepairementItemService from "@/services/master/repairement/vehicleRepairementItemService.js";

export default {
  computed: {
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
  data() {
    return {
      validationErrors: {
        sparePart: null,
      },
      selectedVehicleMaintenance: null,
      isMaintenanceDone: false,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  created() {
    // subscribe message
    this.$eventBus.$on("initializeVehicleMaintenanceItem", this.initialize);
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeVehicleMaintenanceItem");
  },
  methods: {
    openModal() {
      $(this.$refs.vehiclemaintenanceitemmodal).modal();
      $(this.$refs.vehiclemaintenanceitemmodal).css("overflow-y", "auto");
    },
    closeModal() {
      $(this.$refs.vehiclemaintenanceitemmodal).modal("hide");
    },
    async initialize(vehicleMaintenance) {
      try {
        this.isLoading = true;
        this.reset();
        this.selectedVehicleMaintenance = vehicleMaintenance;
        this.isMaintenanceDone = vehicleMaintenance.status === "Done";
        await this.getAll();
        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    resetValidation() {
      this.validationErrors.sparePart = null;
    },
    bindModel(object) {
      this.isEdit = true;
      this.resetValidation();
      this.model = Object.assign({}, object);
    },
    reset() {
      this.isEdit = false;
      this.resetValidation();
      this.model = {};
    },
    async getAll() {
      this.items = await vehicleRepairementItemService.getAll(
        this.selectedVehicleMaintenance.id
      );
    },
    async createItem() {
      if (!this.$helper.validateForm(this, "vehicle-maintenance-item-form")) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.vehicleRepairementId = this.selectedVehicleMaintenance.id;
        this.model.cost = parseFloat(this.model.cost);
        await vehicleRepairementItemService.create(this.model);
        this.$notification.success("Successfully added.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async updateItem(item) {
      if (!this.$helper.validateForm(this, "vehicle-maintenance-item-form")) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.vehicleRepairementId = this.selectedVehicleMaintenance.id;
        this.model.cost = parseFloat(this.model.cost);
        await vehicleRepairementItemService.update(this.model);
        this.$notification.success("Successfully updated.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem(item) {
      try {
        this.isLoading = true;
        await vehicleRepairementItemService.delete(item.id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/repairement/VehicleMaintenanceItem.vue